// extracted by mini-css-extract-plugin
export default {"text":"Apartments_text__k2Sde","container":"Apartments_container__y+Lsn"};